import * as Sentry from '@sentry/react';
import { some } from 'lodash';

import type { LinkObject } from 'bundles/ent-website/contentful/core/Navigation';
import formatPathname from 'bundles/ent-website/utils/formatPathname';

export function isActive(pathname: string, href: string) {
  try {
    const url = new URL(href);
    return url?.pathname === pathname;
  } catch {
    // could not construct URL
    return false;
  }
}

export function isActiveParent(pathname: string, parent: LinkObject, allParents: LinkObject[]): boolean {
  const slug = formatPathname(pathname);

  // Homepages like /campus, /business
  if (!slug) return false;

  // /business/teams edge case
  if (pathname?.includes('/business/teams') && parent.href?.includes('business/teams')) return true;

  // if pathname equals parent pathname - return true
  try {
    if (parent?.href != null && parent?.href !== '') {
      const parentUrl = new URL(parent.href);
      if (parentUrl?.pathname === pathname) return true;
    }
  } catch {
    Sentry.captureException(new Error(`Could not construct URL from ${parent?.href}`));
  }

  // if pathname is another parent pathanme - return false
  const isAnotherParentsPathname = some(allParents, (link) => {
    if (link?.href == null || link?.href === '') return false;

    try {
      const url = new URL(link.href);
      return url.pathname === pathname;
    } catch {
      Sentry.captureException(new Error(`Could not construct URL from ${link?.href}`));
      return false;
    }
  });

  if (isAnotherParentsPathname) return false;

  // Standard parent child link structures
  return some(parent.children, (child) => {
    return some(child.items, (item) => {
      try {
        const ctaUrl = new URL(item?.ctaTarget ?? '');
        return ctaUrl?.pathname === pathname;
      } catch {
        Sentry.captureException(new Error(`Could not construct URL from ${item?.ctaTarget}`));
        return false;
      }
    });
  });
}
